import { all, takeLatest } from 'redux-saga/effects'

import { OCR_REQUEST_TYPES } from './reducers/ocr'
import { handleOcrTypes } from './sagas/ocr'

import { handleGetRequestResult } from './sagas/request'
import { GET_REQUEST_RESULT } from './reducers/request'

import { QUIZ_REQUEST, QUIZ_SUBMIT } from './reducers/quiz'
import { handleFetchQuestions, handleSubmitAnswers } from './sagas/quiz'

export default function* rootSaga() {
  yield all([
    takeLatest(OCR_REQUEST_TYPES, handleOcrTypes),
    takeLatest(GET_REQUEST_RESULT, handleGetRequestResult),
    takeLatest(QUIZ_REQUEST, handleFetchQuestions),
    takeLatest(QUIZ_SUBMIT, handleSubmitAnswers),
  ])
}
